export const appsMultiLanguageSettingsGetLocales = "/apps/multi_language_settings/get_locales";
